package com.mencanhealth.admin.ui.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.*

@Composable
fun StatCard(label: String, value: String, cssClass: String = "") {
    Div({ classes("stat-card", cssClass) }) {
        Div({ classes("stat-value") }) { Text(value) }
        Div({ classes("stat-label") }) { Text(label) }
    }
}
